import React from "react"
import types from "prop-types"

const WhitelistedDescription = ({ description }) => (
  <p className="list-row dark">{ description.description }</p>
)

WhitelistedDescription.propTypes = {
  description: types.object.isRequired,
}

export default WhitelistedDescription
